export default __webpack_public_path__ + "static/media/LC.5107ba0a.svg";